import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import { rhythm, scale, containerStyle } from "../utils/typography";
import NavBar from "./NavBar";
import logo from "../images/biostudent.gif";
import icon from "../images/menu.svg";

import "../index.css";

class DefaultLayout extends Component {
  state = {
    navOpen: false
  };

  toggleMenu() {
    const navOpen = !this.state.navOpen;
    this.setState({ navOpen });
  }

  getNavClass() {
    return `nav-${this.state.navOpen ? "on" : "off"}`;
  }

  render() {
    const mediumUp = "@media screen and (min-width: 768px)";
    const small = "@media screen and (max-width: 767px)";
    return (
      <div>
        <div
          css={{
            padding: 0,
            backgroundImage:
              "radial-gradient(circle at center, #002669 0, #01184f, hsl(221, 100%, 7%) 100%)"
          }}
        >
          <div
            css={{
              ...containerStyle,
              [small]: {
                paddingTop: rhythm(0.5),
                paddingBottom: rhythm(0.5),
                paddingLeft: rhythm(3 / 4),
                paddingRight: rhythm(3 / 4)
              }
            }}
          >
            <div css={{ display: "flex", alignItems: "center" }}>
              <img
                src={logo}
                alt="Біостудент"
                css={{
                  height: 40,
                  margin: "0",
                  [mediumUp]: {
                    height: 80,
                    margin: "0 30px 0 0"
                  }
                }}
              />
              <h1
                css={{
                  margin: 0,
                  fontSize: scale(0.7).fontSize,
                  lineHeight: 1,
                  letterSpacing: "0.2rem",
                  [mediumUp]: {
                    fontSize: scale(1.6).fontSize,
                    lineHeight: 1,
                    letterSpacing: "0.3rem"
                  },
                  [small]: {
                    flexGrow: 1,
                    textAlign: "center"
                  }
                }}
              >
                <Link
                  css={{
                    color: `#fff`,
                    ":hover": {
                      color: `#f1f1f1`,
                      textDecoration: `none`
                    }
                  }}
                  to="/"
                >
                  Біостудент
                </Link>
              </h1>
              <button
                type="button"
                onClick={this.toggleMenu.bind(this)}
                aria-label="Відкрити меню"
                css={{
                  margin: "0 0 -5px auto",
                  background: "none",
                  padding: 0,
                  border: "none",
                  "@media screen and (min-width: 768px)": {
                    display: "none"
                  }
                }}
              >
                <img
                  src={icon}
                  alt="Мобільне меню"
                  css={{
                    margin: 0,
                    height: 32,
                    width: 32,
                    verticalAlign: "middle"
                  }}
                />
              </button>
            </div>
          </div>
        </div>
        <div
          className={this.getNavClass()}
          css={{
            marginBottom: rhythm(1),
            backgroundColor: "#065197"
          }}
        >
          <NavBar></NavBar>
          <span onClick={this.toggleMenu.bind(this)}></span>
        </div>
        <div css={containerStyle}>
          <React.Fragment>{this.props.children}</React.Fragment>
        </div>
      </div>
    );
  }
}

DefaultLayout.propTypes = {
  children: PropTypes.object.isRequired
};

export default DefaultLayout;
